var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hotline-dialog"},[_c('div',{staticClass:"hotline-title"},[_vm._v("服务热线")]),_c('div',{staticClass:"hotline-phone"},[_vm._v("400-009-2860")])])
}]

export { render, staticRenderFns }